import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import UserTable from '../../containers/UserTable'
import NewUserModal from '../../containers/NewUserModal'
import EditUserModal from '../../containers/EditUserModal'
import BookOrUnbookLaundryTimeModal from '../../containers/BookOrUnbookLaundryTimeModal'

class Users extends React.Component {
  render() {
    const { classes } = this.props

    return (
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <UserTable />
        <NewUserModal />
        <EditUserModal />
        <BookOrUnbookLaundryTimeModal />
      </main>
    )
  }
}

const Styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto'
  }
})

Users.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(Styles)(Users)



// WEBPACK FOOTER //
// ./src/components/pages/Users/index.js